import React, { Component } from "react";
import AgentHighlights from '../agent/AgentHighlights.js';

export default class PageProjectList extends Component {
  	
	render () {
		
		let block = this.props.block;
				
		if (block) {
									
			return (
			    
			    <div data-id={block.id} className={'c-page__block c-page__block--load-effect c-page__block--space-' + block.space_after + ' c-page__block--' + block.rule_after}>
			    
			    	<div className="l-content l-content--fixed-width">
			    		
			    		<div className="l-grid">
			    		
			    			<div className="l-grid__col">
			    				
			    				<AgentHighlights projects={block.projects}></AgentHighlights>		    			
																
							</div>
			    			
			    		</div>
			    		
			    	</div>
			    
			    </div>
			)
			
		} else {
			
			return null;
		
		}
	}
}
